export default __webpack_public_path__ + "static/media/statement-no-preview-small.31aa2b04.svg";